if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });
    
    $('.press-slider').slick({
        centerMode: true,
        centerPadding: '0px',
        dots:false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        fade: false,
        appendArrows: '.arrows-holder',
        initialSlide: 0,
        responsive: [
            {
            breakpoint: 769,
            settings: {
                centerMode: false,
                centerPadding: '0px',
                slidesToShow: 2,
                slidesToScroll: 3,
                }
            },
            {
            breakpoint: 641,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 3
            }
            }	
        ]
    });

    if(document.querySelector('.sym-slides-dots')){
        $('.sym-slides-dots').slick({
            accessibility: false,
            dots: true,
            arrows: false,
            infite:true
        });
    }


    if(document.getElementsByClassName('nofollow').length > 0){ // iff there is no follow link
        let allNoFollow = document.getElementsByClassName('nofollow');

        for(let i =0; i < allNoFollow.length; i++){
            allNoFollow[i].addEventListener('click', function(e){
                e.preventDefault();
                animateTo(this.getAttribute('href').split('#')[1])
            })
        }

    }

    

    // slick hover
    // $(".slick-slider").mousemove(function (e) {
    //     if ((e.pageX - this.offsetLeft) < $(this).width() / 1.5) {
    //         $(this).remove('hover-right');
    //         $(this).addClass('hover-left');
    //     } else {
    //         $(this).removeClass('hover-left');
    //         $(this).addClass('hover-right');
    //     }
    // });
    // $(".slick-slider").on('click', function (e) {
    //     if ((e.pageX - this.offsetLeft) < $(this).width() / 1.5) {
    //         $(this).slick("slickPrev");
    //     } else {
    //         $(this).slick("slickNext");
    //     }
    // });
    // $('.slick-slider').mouseout(function () {
    //     $(this).removeClass('hover-right');
    //     $(this).removeClass('hover-left');
    // })

})();


//vanilla js scroll TO animation
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function isDesktop() {
    return window.innerWidth > 768;
}

window.addEventListener('DOMContentLoaded', function() {
    if (isDesktop() && window.sierra && !localStorage.getItem('sierraChatMinimized')) {
        if (window.sierra && typeof window.sierra.openChatModal === 'function') {
            window.sierra.openChatModal();
        } else {
            // If Sierra hasn't loaded yet, wait for it
            window.addEventListener('sierra:ready', function() {
                window.sierra.openChatModal();
            });
        }
    }
});